/* eslint-disable jsx-a11y/aria-role */
import { useCallback, useEffect, useId, useMemo, useRef, useState } from 'react'
import './PatientChart.scss'
import { useDispatch } from 'react-redux'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import FlatList from 'flatlist-react'
import {
  AllergiesPopUp,
  CharacterLimitCounter,
  ErrorAlert,
  FileCard,
  Order,
  PageLoadingSpinner,
  PrescriptionPopUp,
  PrimaryButton,
  TextEditor,
  UploadFilePopUp,
  useAdjustPageHeadEntities,
  // @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
} from 'ui_kit_qmd'
import Switch from 'react-switch'
import { useNavigate, useSearchParams } from 'react-router-dom'
import classNames from 'classnames'
import { transformBackendToUIStatus, formatNameForPatientChartTitle, getFreeDrugRuleLayout } from './helper'
import errorIcon from '../../../images/common/error-icon.svg'
import {
  checkIsNeedUpdatePatientChartSection,
  getStateByAbbreviation,
  getTabId,
  isActiveEllipsisCheck,
  isObjectEmpty,
  parseTimeZone,
  parseUserDateTime,
  getPharmacyAddressValue,
} from '../../../utils/common'
import { safeLocalStorage } from '@quickmd-llc/frontend-utils'
import flag from '../../../images/common/flag.png'
import accountInfoIcon from '../../../images/PatintChartsPillIcon/account-info.png'
import prescripitionsIcon from '../../../images/PatintChartsPillIcon/prescriptions-icon.png'
import generalInfoSectionIcon from '../../../images/charts/generalInformationSectionIcon.png'
import pastVisitsIcon from '../../../images/charts/calendar-clock.png'
import upcomingVisitsIcon from '../../../images/charts/upcomingVisitIcon.png'
import intakeFormsIcon from '../../../images/charts/intakeForms.png'
import filesIcon from '../../../images/common/file.png'
import plus from '../../../images/common/plusIcon.png'
import { ChartCard } from './components/chart-card/ChartCard'
import { SecondaryButton } from '../../../components/ui_kit_quickMD/secondary-button/secondarybutton'
import { AlertCard } from './components/alert-card/AlertCard'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import DeleteAlertPopUp from '../DeleteAlertPopUp/DeleteAlertPopUp'
import { accountInfo, getMaritalEnum, getMaritalValue, getRacialEnum, getRacialValue, text } from './Constants'
import { InfoCard } from './components/info-card/InfoCard'
import { mergeIntakeFormsAndQuestionnaires } from './utils/intakeFormsAndQuestionnaires'
import { useGetPatientsPatientIdQuestionnaires } from 'api/generated/questionnaire/questionnaire'
import { ChartListener } from '../ChartListener'
import { VisitCard } from './components/visit-card/VisitCard'
import { GeneralInfoEdit } from './components/general-info-edit/GeneralInfoEdit'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { ProviderPage } from '../../../components/provider-page/ProviderPage'
import {
  ALERTS_SECTIONS_EMPTY_TEXT,
  ARE_YOU_SURE,
  CANCEL_TEXT,
  CONFIRM_TEXT,
  FILES_TEXT,
  NO_FILES_TEXT,
  PATIENT_CHART_INTAKE_QUESTIONS_PAGE_PATH,
  PATIENT_PAST_VISIT_PAGE_PATH,
  PATIENT_UPCOMING_VISIT_PAGE_PATH,
  REMOVE_ALLERGIES_CONFIRMATION,
} from '../../../utils/constants'
import { getProducts, getPastVisitsForProduct } from '../../../store/products/productsThunk'
import { useQueryClient } from '@tanstack/react-query'
import {
  useGetPatientsPatientIdPrescriptions,
  getGetPatientsPatientIdPrescriptionsQueryKey,
  getVisitsVisitIdEncounterUrl,
} from '../../../api/generated/prescription/prescription'
import { mapPrescriptionToLegacy } from '../../../utils/prescriptionMapper'
import {
  addAlert,
  addMediaFile,
  addPatientAllergy,
  deleteAlert,
  deletePatientAllergy,
  editAlert,
  geIntakeForms,
  getMediaFiles,
  getPastVisits,
  getPatientChart,
  getPatientTreatLink,
  getUpcomingVisits,
  markAllUserAlertsAsRead,
  saveAccountInfo,
  saveGeneralInfo,
  setMediaFileTags,
  setPatientHasAllergies,
  setPatientHasNoAllergies,
} from '../../../store/charts/ChartsThunk'
import {
  clearPatientChartTreatLink,
  clearPatientData,
  dropChartError,
  setChartError,
  setIsAccountInfoUpdatedSuccess,
  setPatientIdForResetMediaFiles,
  setVisitProvider,
} from '../../../store/charts/ChartsActions'
import { AccountInformationView } from './components/account-information-view/AccountInformationView'
import { IS_INTAKE_QUESTIONS_FORM } from './components/intake-questions/components/IntakeQuestionsConsttants'
import { apiCall } from '../../../utils/restclient'
import { generateLoggPatientChartAccessData, postHIPAALogMessage } from '../../../utils/HippaLoggingHelper'
import PatientInfoTile from './components/patient-info-tile/PatientInfoTile'
import { ConfirmationPopup } from '../../../components/confirmation-popup/confirmationpopup'
import { setDrugRulesSettingsByUserId } from '../../../store/drugRulesSettings/drugRulesSettingsActions'
import { useMediaFiles } from './hooks/useMediaFiles'
import { useTrackViewPatientChart } from './hooks/useTrackViewPatientChart'
import { ProductOrderPopUp } from '../../../components/product-order-popup/ProductOrderPopUp'
import { ButtonOptionsSelector } from '../../../components/button-options-selector/ButtonOptionsSelector'
import { selectDtsMoudPilotEnabled } from '../../../store/flags/FlagsSelectors'
import { PROVIDER_EVENT_NAMES, tracking } from 'lib/segment/tracking'
import { EventLocations } from 'lib/segment/constants'
import { windowOpenArgs } from 'utils/windowOpenArgs'
import { useSelector } from 'store/hooks/useSelector'
import { PageLayout } from 'components/page-layouts/PageLayout'
import { useIsProviderScriptSureCohort } from 'hooks/useIsProviderScriptSureCohort'
import { ALLOWED_FILE_EXTENSIONS, ALLOWED_FILE_EXTENSIONS_STR, SIZE_10_MB } from 'constants/fileUpload'

const TREAT_SYNC_ERROR_TIMEOUT_MS = 7000

const noop = () => {}

const removeAllAllergiesPopUpStyle = { marginTop: 0, alignSelf: 'center', width: 717, alignItems: 'center' }

const AlertsNewBtnContainerStyle = {
  maxHeight: 40,
  width: 66,
  justifyContent: 'center',
  marginTop: 20,
}
const saveButton = {
  height: 40,
  width: 65,
  marginTop: 20,
  boxSizing: 'border-box',
}
const editButton = {
  height: 40,
  width: 55,
  marginTop: 20,
  boxSizing: 'border-box',
}
const AlertsNewBtnImgStyle = {
  height: 16.5,
  width: 16.5,
  marginRight: 5,
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const getContainerStyle = (uploadFileError) => {
  const width = uploadFileError === '210 - Cannot upload file that is bigger than 10 MB.' ? 580 : 550
  return { width }
}

// @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
let deleteAlertIdForCheck = null
const alertsKey = uuidv4()

const PatientChart = () => {
  const [params] = useSearchParams()
  const id = params.get('id')
  const tabId = getTabId()
  const allergiesPopUpRef = useRef()
  const dispatch = useDispatch()
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const fileCardRef = useRef()
  // @ts-expect-error TS2538 -- MIGRATION: not approved, fix when encountered
  const patientInfo = useSelector((state) => state.chartsReducer.patientInfo?.[id] || {})
  const loading = useSelector((state) => state.chartsReducer.loading)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const commonChartsError = useSelector((state) => state.chartsReducer.error)
  // @ts-expect-error TS2538 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.chartsReducer.patientInfo?.[id]?.error || '')
  // @ts-expect-error TS2538 -- MIGRATION: not approved, fix when encountered
  const alerts = useSelector((state) => state.chartsReducer.patientInfo?.[id]?.alerts || null)
  // @ts-expect-error TS2538 -- MIGRATION: not approved, fix when encountered
  const pastVisits = useSelector((state) => state.chartsReducer.patientInfo?.[id]?.pastVisits || [])
  // @ts-expect-error TS2538 -- MIGRATION: not approved, fix when encountered
  const upcomingVisits = useSelector((state) => state.chartsReducer.patientInfo?.[id]?.upcomingVisits || [])
  // @ts-expect-error TS2538 -- MIGRATION: not approved, fix when encountered
  const intakeForms = useSelector((state) => state.chartsReducer.patientInfo?.[id]?.intakeForms || [])

  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const patientSettings = useSelector((state) => state.drugRulesSettingsReducer?.patientSettings?.[id])

  const patientDrugRules =
    patientSettings?.DrugScreenHtml ||
    getFreeDrugRuleLayout(getStateByAbbreviation(patientInfo?.Address?.StateCode?.toUpperCase()))
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const alertsEmptyMsg = useSelector((state) => state.chartsReducer?.alertsEmptyMsg)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const getAlertsSuccess = useSelector((state) => state.chartsReducer.getAlertsSuccess)
  // @ts-expect-error TS2538 -- MIGRATION: not approved, fix when encountered
  const patientTreatLink = useSelector((state) => state.chartsReducer.patientInfo?.[id]?.patientTreatLink || null)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const allergyNameError = useSelector((state) => state.chartsReducer.allergyNameError)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const allergySeverityError = useSelector((state) => state.chartsReducer.allergySeverityError)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const settingsPerState = useSelector((state) => state.drugRulesSettingsReducer.settingsPerState)
  const profile = useSelector((state) => state.waitingRoomReducer.providerProfile)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const isNeedToUpdatePastVisits = useSelector((state) => state.chartsReducer.isNeedToUpdatePastVisits)
  const flags = useSelector((state) => state.flags.flags)
  const dtsMoudPilotEnabled = useSelector(selectDtsMoudPilotEnabled)
  const isProviderScriptSure = useIsProviderScriptSureCohort()

  const { filteredMediaFiles, getTagFilter, mediaFiles } = useMediaFiles({ id })

  const [isShowNamesPopUp, setIsShowNamesPopUp] = useState(false)
  const [sortedAlerts, setSortedAlerts] = useState([])
  const [newAlertOpened, setNewAlertOpened] = useState(false)
  const [isVisibleAllChecked, setIsVisibleAllChecked] = useState(true)
  const [editAlertOpened, setEditAlertOpened] = useState(null)
  const [showAlertInfo, setShowAlertInfo] = useState(false)
  const [showAccountCardInfo, setsShowAccountCardInfo] = useState(false)
  const [showPrescriptionsCardInfo, setShowPrescriptionsCardInfo] = useState(false)
  const [showPastVisits, setShowPastVisits] = useState(false)
  const [showUpcomingVisits, setShowUpcomingVisits] = useState(false)
  const [showIntakeForms, setShowIntakeForms] = useState(false)
  // Online-visit questionnaires via the Orval hook (React Query) — fetched lazily once the
  // Intake forms section is expanded. Replaces the legacy chartsReducer thunk.
  const { data: questionnaires = [] } = useGetPatientsPatientIdQuestionnaires(id ?? '', {
    query: { enabled: Boolean(id) && showIntakeForms },
  })
  const [isDefaultAlertSet, setIsDefaultAlertSet] = useState(false)
  const [alertLocalError, setAlertLocalError] = useState('')
  const [newAlertText, setNewAlertText] = useState('')
  const [editAlertText, setEditAlertText] = useState('')
  const [deleteAlertId, setDeletedAlertId] = useState(null)
  const [isShowGeneralInfo, setIsShowGeneralInfo] = useState(false)
  const [isGeneralInfoEditMode, setIsGeneralInfoEditMode] = useState(false)
  const [generalInfo, setGeneralInfo] = useState(null)
  const [accountCardInfo, setAccountCardInfo] = useState(null)
  const [isFirstMount, setIsFirstMount] = useState(true)
  const [isAccountInformationEditMode, setIsAccountInformationEditMode] = useState(false)
  const [isAccountInformationSaveBtnClicked, setIsAccountInformationSaveBtnClicked] = useState(false)
  const [isCheckNumberInProgress, setIsCheckNumberInProgress] = useState(false)
  const [isShowFiles, setIsShowFiles] = useState(false)
  const [filesHasOpened, setFilesHasOpened] = useState(false)
  const [uploadedFile, setUploadedFile] = useState({})
  const [uploadFileError, setUploadFileError] = useState('')
  const [isUploadFilePopUp, setUploadFilePopUp] = useState(false)
  const [removeAllAllergiesPopUp, setRemoveAllAllergiesPopUp] = useState(false)
  const [isNewPatientAgeValueLessThen18, setIsNewPatientAgeValueLessThen18] = useState(false)

  const sideBarRef = useRef()
  const [isEmergencyError, setIsEmergencyError] = useState(false)
  const isLoggedIn = useSelector((state) => state.auth.accessToken)
  const [isSideCollapsed, setIsSideCollapsed] = useState(false)
  const [localLoading, setLocalLoading] = useState(false)
  const [localToastErrorMessage, setLocalToastErrorMessage] = useState('')
  const [isNeedToShowPastVisits, setIsNeedToShowPastVisits] = useState(false)
  const [isNeedToShowUpcomingVisits, setIsNeedToShowUpcomingVisits] = useState(false)
  const [isNeedToShowIntakeForms, setIsNeedToShowIntakeFroms] = useState(false)
  const [allergiesCount, setAllergiesCount] = useState(0)
  const [localPastVisitsList, setLocalPastVisitsList] = useState([])
  const [localUpcomingVisitsList, setLocalUpcomingVisitsList] = useState([])
  const [localIntakeFormsList, setLocalIntakeFormsList] = useState([])
  const [localAlertsEmptyMessage, setLocalAlertsEmptyMessage] = useState('')
  const [isShowFileCardPopup, setIsShowFileCardPopup] = useState(false)
  const [isNeedToUpdateLocalPastVisitsList, setIsNeedToUpdateLocalPastVisitsList] = useState(false)
  const [successDeletedAlertId, setSuccessDeletedAlertId] = useState(null)
  const [isAllergiesPopUpOpened, setIsAllergiesPopUpOpened] = useState(false)
  const [prescription, setPrescription] = useState(null)
  const [showPrescriptionsExpanded, setShowPrescriptionsExpanded] = useState(false)

  const { data: rawPrescriptionsList = [], isLoading: isPrescriptionsLoading } = useGetPatientsPatientIdPrescriptions(
    // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
    id,
    {
      query: { enabled: showPrescriptionsExpanded && !!id },
    },
  )
  const localPrescriptionsList = useMemo(
    () => rawPrescriptionsList.map(mapPrescriptionToLegacy),
    [rawPrescriptionsList],
  )

  const { FirstName, LastName, TreatSyncError } = patientInfo || {}
  const pageTitle = `${formatNameForPatientChartTitle(FirstName, LastName)} - Patient Chart`
  const pageHeader = useAdjustPageHeadEntities({
    title: pageTitle,
  })

  const styleContainer = getContainerStyle(uploadFileError)

  useTrackViewPatientChart()

  useEffect(() => {
    if (settingsPerState && patientInfo?.Address?.StateCode) {
      dispatch(
        setDrugRulesSettingsByUserId({
          patientId: id,
          patientHomeAddressState: patientInfo?.Address?.StateCode,
        }),
      )
    }
  }, [patientInfo, settingsPerState])

  useEffect(() => {
    if (sideBarRef) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const sideBarState = sideBarRef.current?.isSideBarCollapsed()
      setIsSideCollapsed(sideBarState)
    }
  }, [sideBarRef])

  useEffect(() => {
    if (id) {
      postHIPAALogMessage(
        generateLoggPatientChartAccessData({
          userId: profile?.ProviderId || '',
          patientId: id,
        }),
      )
    }
  }, [id])
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const onCollapseSidePanel = (newStatus) => {
    setTimeout(() => {
      setIsSideCollapsed(newStatus)
    }, 200)
  }
  const openUploadFilePopUp = () => setUploadFilePopUp(true)
  const closeUploadFilePopUp = () => setUploadFilePopUp(false)

  const newAlertRef = useRef(null)
  const editAlertRef = useRef(null)
  const openTreatOnSuccess = useRef(false)
  const generalInfoRef = useRef()
  const accountInfoRef = useRef()

  const accountData = accountInfo(patientInfo, text.PERSONAL)
  const accountInfoLastUpdateInfo = accountInfo(patientInfo, text.LAST_UPDATE)
  const bodyMeasurementsData = accountInfo(patientInfo, text.BODY_MEASUREMENTS)
  const identityData = accountInfo(patientInfo, text.IDENTITY)

  // Intake forms and online-visit questionnaires render in the same section, tagged by type so the
  // click target differs (intakeFormId vs sessionId). See utils/intakeFormsAndQuestionnaires.
  const intakeFormsAndQuestionnaires = useMemo(
    () => mergeIntakeFormsAndQuestionnaires(localIntakeFormsList, questionnaires),
    [localIntakeFormsList, questionnaires],
  )

  const MAX_CHARACTER_LIMIT = 5000

  useEffect(() => {
    if (isEmergencyError) {
      setIsEmergencyError(false)
    }
    if (Object.keys(patientInfo).length) {
      setAccountCardInfo((prev) => ({
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        ...prev,
        prefferedNameValue: patientInfo.PreferredName || '',
        emergencyFirstNameValue: patientInfo?.EmergencyContact?.FirstName || '',
        emergecyLastNameValue: patientInfo?.EmergencyContact?.LastName || '',
        emergencyRelationshipValue: patientInfo?.EmergencyContact?.Relationship || '',
        contactPharmacyValue: getPharmacyAddressValue(patientInfo.Pharmacy) || '',
        emergencyPhoneNumber:
          patientInfo?.EmergencyContact?.PhoneNumber?.Number?.substr(
            patientInfo?.EmergencyContact?.PhoneNumber?.Prefix?.length,
          ) || '',
        selectedPharmacyAddress: getPharmacyAddressValue(patientInfo.Pharmacy) || '',
        emergencyPhoneError: '',
        emergencyPhoneCountryCode: patientInfo?.EmergencyContact?.Prefix?.substr(1) || '1',
        emergencyPhoneCountry: patientInfo?.EmergencyContact?.PhoneNumber?.CountryCode?.toLowerCase() || 'us',
        selectedPharmacyId: null,
        selectedPharmacy: null,
        isPhoneChanged: false,
        isEmergencyContactError: isEmergencyError,
      }))
    }
  }, [patientInfo, isEmergencyError])

  useEffect(() => {
    const isNeedToResetAllergies = checkIsNeedUpdatePatientChartSection(tabId)
    if (isNeedToResetAllergies) {
      setAllergiesCount(patientInfo?.AllergyCollection?.Allergies?.length || '0')
    }
  }, [patientInfo?.AllergyCollection?.Allergies?.length, tabId])

  useEffect(() => {
    const isNeedToUpdate = checkIsNeedUpdatePatientChartSection(tabId)

    if (isNeedToUpdate && !localPastVisitsList.length) {
      setLocalPastVisitsList(pastVisits || [])
    }
  }, [pastVisits?.length])

  useEffect(() => {
    if (isNeedToUpdateLocalPastVisitsList) {
      setIsNeedToUpdateLocalPastVisitsList(false)
      setLocalPastVisitsList(pastVisits)
    }
  }, [isNeedToUpdateLocalPastVisitsList])

  useEffect(() => {
    const isNeedToUpdateUpcomingVisits = checkIsNeedUpdatePatientChartSection(tabId)

    if (isNeedToUpdateUpcomingVisits && !localUpcomingVisitsList.length) {
      setLocalUpcomingVisitsList(upcomingVisits || [])
    }
  }, [upcomingVisits?.length])

  useEffect(() => {
    const isNeedToUpdateIntakeFormsList = checkIsNeedUpdatePatientChartSection(tabId)

    if (isNeedToUpdateIntakeFormsList && !localIntakeFormsList.length) {
      setLocalIntakeFormsList(intakeForms || [])
    }
  }, [intakeForms?.length])

  useEffect(() => {
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    if (accountCardInfo && !accountCardInfo?.contactPharmacyValue) {
      setAccountCardInfo((prev) => ({
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        ...prev,
        contactPharmacyValue: getPharmacyAddressValue(patientInfo?.Pharmacy) || '',
        selectedPharmacyAddress: getPharmacyAddressValue(patientInfo?.Pharmacy) || '',
      }))
    }
  }, [patientInfo?.Pharmacy])

  const updateAccountInfo = () => {
    setIsAccountInformationEditMode(false)
    setAccountCardInfo({
      // @ts-expect-error TS2353 -- MIGRATION: not approved, fix when encountered
      prefferedNameValue: patientInfo.PreferredName || '',
      emergencyFirstNameValue: patientInfo?.EmergencyContact?.FirstName || '',
      emergecyLastNameValue: patientInfo?.EmergencyContact?.LastName || '',
      emergencyRelationshipValue: patientInfo?.EmergencyContact?.Relationship || '',
      contactPharmacyValue: getPharmacyAddressValue(patientInfo.Pharmacy) || '',
      emergencyPhoneNumber:
        patientInfo?.EmergencyContact?.PhoneNumber?.Number?.substr(
          patientInfo?.EmergencyContact?.PhoneNumber?.Prefix?.length,
        ) || '',
      selectedPharmacyAddress: getPharmacyAddressValue(patientInfo.Pharmacy) || '',
      emergencyPhoneError: '',
      emergencyPhoneCountryCode: patientInfo?.EmergencyContact?.Prefix?.substr(1) || '1',
      emergencyPhoneCountry: patientInfo?.EmergencyContact?.PhoneNumber?.CountryCode?.toLowerCase() || 'us',
      selectedPharmacyId: null,
      selectedPharmacy: null,
      isPhoneChanged: false,
    })
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    dispatch(setIsAccountInfoUpdatedSuccess())
  }

  const onScrollUpAlertCard = () => {
    const alertCardContainer = document.getElementById('chartCardContainerAlerts')
    if (alertCardContainer) {
      alertCardContainer.scrollTo(0, 0)
    }
  }
  const onPressAlertsNewBtn = () => {
    setNewAlertOpened(true)
    setShowAlertInfo(true)
    setNewAlertText('')
    setAlertLocalError('')
    onScrollUpAlertCard()
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const toggleShowAlertsCardInfo = (value) => {
    setShowAlertInfo(value)

    if (value) {
      setTimeout(() => {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        newAlertRef?.current?.onSetValue(newAlertText)
      }, 1)
    }
    if (editAlertRef && editAlertText) {
      setTimeout(() => {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        editAlertRef?.current?.onSetValue(editAlertText)
      }, 1)
    }
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const toggleShowAccountCardInfo = (value) => {
    if (showAccountCardInfo && isAccountInformationEditMode) {
      // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
      setAccountCardInfo((prev) => ({ ...accountInfoRef.current.getInfo(), isError: prev.isError }))
    }
    setsShowAccountCardInfo(value)
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const toggleShowGeneralInfo = (value) => {
    if (isShowGeneralInfo && isGeneralInfoEditMode) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setGeneralInfo(generalInfoRef?.current?.getInfo())
    }
    setIsShowGeneralInfo(value)
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const toggleShowPrescriptionsCardInfo = (value) => {
    setShowPrescriptionsExpanded(value)
    setShowPrescriptionsCardInfo(value)
  }
  const toggleShowPastVisits = () => {
    if (
      (!showPastVisits &&
        patientInfo?.VisitSummary?.CountPast &&
        pastVisits.length === 0 &&
        localPastVisitsList.length === 0) ||
      isNeedToUpdatePastVisits
    ) {
      setIsNeedToShowPastVisits(true)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getPastVisits(patientInfo.PatientId, tabId))
      return
    }
    setShowPastVisits(!showPastVisits)
  }
  const toggleShowUpcomingVisits = () => {
    if (
      !showUpcomingVisits &&
      patientInfo?.VisitSummary?.CountUpcoming &&
      upcomingVisits.length === 0 &&
      localUpcomingVisitsList.length === 0
    ) {
      setIsNeedToShowUpcomingVisits(true)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getUpcomingVisits(patientInfo.PatientId, tabId))
      return
    }
    setShowUpcomingVisits((prev) => !prev)
  }
  const toggleIntakeForms = () => {
    if (!showIntakeForms && patientInfo?.IntakeFormSummary?.Count && localIntakeFormsList.length === 0) {
      setIsNeedToShowIntakeFroms(true)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(geIntakeForms(patientInfo.PatientId, tabId))
      return
    }
    setShowIntakeForms(!showIntakeForms)
  }

  const toggleMediaFiles = () => {
    if (!patientInfo?.MediaFileSummary?.Count && !filesHasOpened) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setPatientIdForResetMediaFiles(id))
      setTimeout(() => {
        dispatch(setPatientIdForResetMediaFiles())
      }, 2000)
    }
    if (!isShowFiles && patientInfo?.MediaFileSummary?.Count && (!mediaFiles?.length || !filesHasOpened)) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getMediaFiles({ patientId: id, mediaFiles: [], tabId }))
    } else {
      if (!filesHasOpened) setFilesHasOpened(true)

      setIsShowFiles(!isShowFiles)
    }
  }

  const alertAddedSuccess = () => {
    setNewAlertOpened(false)
    setEditAlertOpened(null)
    setEditAlertText('')
    setIsVisibleAllChecked(true)
  }

  useEffect(() => {
    const timer = setInterval(() => {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      isActiveEllipsisCheck('FirstLastChartPatientName', setIsShowNamesPopUp)
    }, 3000)
    return () => clearInterval(timer)
  }, [])

  useEffect(() => {
    if (localPastVisitsList.length && !isFirstMount && isNeedToShowPastVisits) {
      setIsNeedToShowPastVisits(false)
      setShowPastVisits(true)
    }
  }, [localPastVisitsList.length, isFirstMount, isNeedToShowPastVisits])

  useEffect(() => {
    if (localUpcomingVisitsList?.length && !isFirstMount && isNeedToShowUpcomingVisits) {
      toggleShowUpcomingVisits()
    }
  }, [localUpcomingVisitsList.length, isFirstMount, isNeedToShowUpcomingVisits])

  useEffect(() => {
    if (localIntakeFormsList?.length && !isFirstMount && isNeedToShowIntakeForms) {
      setIsNeedToShowIntakeFroms(false)
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      toggleIntakeForms(true)
    }
  }, [localIntakeFormsList.length, isFirstMount, isNeedToShowIntakeForms])

  useEffect(() => {
    if (alerts?.length) {
      setTimeout(() => {
        setLocalAlertsEmptyMessage(ALERTS_SECTIONS_EMPTY_TEXT)
      }, 3000)
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setSortedAlerts(() =>
        [...alerts].sort((a, b) => (moment(a?.UpdateDateTime).isBefore(moment(b?.UpdateDateTime)) ? 1 : -1)),
      )
    } else {
      const isNeedToResetAlerts = checkIsNeedUpdatePatientChartSection(tabId)

      if (isNeedToResetAlerts) {
        setSortedAlerts([])
      }
    }
  }, [alerts])

  useEffect(() => {
    if (getAlertsSuccess && !isDefaultAlertSet) {
      setIsVisibleAllChecked(true)
      setShowAlertInfo(alerts?.length > 0)
      setIsDefaultAlertSet(true)
      if (patientInfo?.AlertSummary?.HasUnread) {
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(markAllUserAlertsAsRead(patientInfo?.PatientId, tabId))
      }
    }
  }, [getAlertsSuccess, alerts, patientInfo.PatientId])

  useEffect(() => {
    if (deleteAlertId) {
      deleteAlertIdForCheck = deleteAlertId
    }
  }, [deleteAlertId])

  useEffect(() => {
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    if (editAlertOpened?.alertId === successDeletedAlertId) {
      setEditAlertOpened(null)
      setSuccessDeletedAlertId(null)
    }
  }, [alerts])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const deleteAlertsSuccess = (alertId) => {
    // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
    if (deleteAlertIdForCheck === alertId) {
      setDeletedAlertId(null)
      deleteAlertIdForCheck = null
    }
  }

  useEffect(() => {
    if (isLoggedIn && isFirstMount) {
      // localStorage.setItem('reloadedPatientChartPageTabId', tabId);
      dispatch(clearPatientData(id, tabId))
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getPatientChart(id, tabId))
      setIsFirstMount(false)
    }
  }, [])

  useEffect(() => {
    if (error) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      if (error === getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'alert message')) {
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setAlertLocalError(getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'alert message'))
      }
      setTimeout(() => {
        setLocalToastErrorMessage('')
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        dispatch(setChartError({ errorMsg: '', patientId: id, tabId }))
      }, 3500)
    }
  }, [error])

  useEffect(() => {
    // @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
    let timer
    if (TreatSyncError) {
      setLocalToastErrorMessage(
        `Patient's Treat profile could not be created. Please correct error to enable Treat prescribing. Error: ${TreatSyncError}`,
      )
      timer = setTimeout(() => {
        setLocalToastErrorMessage('')
      }, TREAT_SYNC_ERROR_TIMEOUT_MS)
    }
    return () => {
      // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
      if (timer) clearTimeout(timer)
    }
  }, [TreatSyncError])

  useEffect(() => {
    setTimeout(() => {
      setUploadFileError('')
    }, 3500)
  }, [uploadFileError])

  useEffect(() => {
    if (commonChartsError) {
      setTimeout(() => {
        setLocalToastErrorMessage('')
        dispatch(dropChartError())
      }, 3500)
    }
  }, [commonChartsError])
  const getAlertView = () => (
    <div className='patient-chart-alerts-container'>
      <FlatList
        displayGrid
        minColumnWidth='45%'
        gridGap='16px'
        list={sortedAlerts}
        renderItem={(item) => (
          <AlertCard
            onScrollUpAlertCard={onScrollUpAlertCard}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            key={item?.AlertId}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            id={item.AlertId}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            IsPrivate={item.IsPrivate}
            newAlertOpened={newAlertOpened}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            isEditAllowed={item.IsEditAllowed}
            editAlertOpened={editAlertOpened}
            setEditAlertOpened={setEditAlertOpened}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            message={item.Message}
            setDeletedAlertId={setDeletedAlertId}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            fullName={`${item.Author.Prefix ? `${item.Author.Prefix} ` : ''} ${item.Author.FirstName} ${
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              item.Author.LastName
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            } ${item.Author.Suffix ? item.Author.Suffix : ''}`?.trim()}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            role={`${item.Author.UserType[0].toUpperCase() + item.Author.UserType.slice(1)}`}
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            lastUpdate={item?.UpdateDateTime}
          />
        )}
      />
    </div>
  )

  const getPrescriptionsView = () =>
    isPrescriptionsLoading ?
      <PageLoadingSpinner />
    : <div className='patient-chart-prescriptions-container'>
        <FlatList
          displayGrid
          minColumnWidth='45%'
          gridGap='16px'
          list={localPrescriptionsList || []}
          renderItem={(item) => (
            <Order
              isProvider
              order={{ ...item }}
              onOpenOrder={() => {
                const { PatientId, VisitSummary } = patientInfo

                tracking.trackEvent(PROVIDER_EVENT_NAMES.VIEW_ORDER, {
                  OrderBrand: item.Brand,
                  OrderCreatedAt: item.CreatedAt,
                  OrderDrugName: item.DrugName,
                  OrderStatus: item.Status,
                  OrderType: item.Type,
                  PatientId,
                  PatientPastVisitCount: VisitSummary?.CountPast,
                  PatientUpcomingVisitCount: VisitSummary?.CountUpcoming,
                })

                // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
                setPrescription({ ...item })
              }}
            />
          )}
        />
      </div>

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onClickPastVisitArrow = (visit) => () => {
    dispatch(setVisitProvider(visit.Provider, visit.VisitId))
    // @ts-expect-error TS2551 -- MIGRATION: not approved, fix when encountered
    navigate(`${PATIENT_PAST_VISIT_PAGE_PATH}?ref=${EventLocations.patientChart}`, {
      state: { patientId: id, visitId: visit.VisitId },
    })
  }

  const getPastVisitsView = () => (
    <div className='patient-chart-past-visit-card-container'>
      <FlatList
        displayGrid
        minColumnWidth='45%'
        gridGap='16px'
        list={localPastVisitsList || []}
        renderItem={(visit, index) => (
          <VisitCard
            visit={visit}
            id={`past-visit${index}`}
            onClickArrowAction={onClickPastVisitArrow(visit)}
            showStatus
          />
        )}
      />
    </div>
  )

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onClickUpcomingVisitArrow = (visit) => () => {
    dispatch(setVisitProvider(visit.Provider, visit.VisitId))
    // @ts-expect-error TS2551 -- MIGRATION: not approved, fix when encountered
    navigate(`${PATIENT_UPCOMING_VISIT_PAGE_PATH}?ref=${EventLocations.patientChart}`, {
      state: { patientId: id, visitId: visit.VisitId },
    })
  }

  const getUpcomingVisitsView = () => (
    <div className='patient-chart-past-visit-card-container'>
      <FlatList
        displayGrid
        minColumnWidth='45%'
        gridGap='16px'
        list={localUpcomingVisitsList || []}
        renderItem={(visit, index) => (
          <VisitCard
            visit={visit}
            id={`past-visit${index}`}
            onClickArrowAction={onClickUpcomingVisitArrow(visit)}
            showStatus
          />
        )}
      />
    </div>
  )

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const handleAddAlert = (type, alertText, IsPrivate) => {
    const Message = alertText.replace(/(\r\n|\r|\n){3,}/g, '$1\n')
    if (Message.replaceAll('\n', '')?.trim() === '') {
      dispatch(
        setChartError({
          errorMsg: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS),
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          patientId: id,
          tabId,
        }),
      )
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setAlertLocalError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Alert message'))
      return
    }

    if (editAlertText?.length > MAX_CHARACTER_LIMIT || newAlertText?.length > MAX_CHARACTER_LIMIT) {
      dispatch(
        setChartError({
          errorMsg: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS),
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          patientId: id,
          tabId,
        }),
      )
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setAlertLocalError(getUserFriendlyErrorMessage(errorCodes.MAX_CHARACTER_LIMIT, null, 'Alert message'))
      return
    }

    const { PatientId, VisitSummary } = patientInfo

    if (type === 'add') {
      tracking.trackEvent(PROVIDER_EVENT_NAMES.ADD_ALERT, {
        PatientId,
        PatientUpcomingVisitCount: VisitSummary?.CountUpcoming,
        // @ts-expect-error TS2561 -- MIGRATION: not approved, fix when encountered
        PatientPastVisitCount: VisitSummary?.CountPast,
      })
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(addAlert({ Message, patientId: PatientId, IsPrivate, tabId }))
    } else {
      dispatch(
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        editAlert({
          Message,
          patientId: PatientId,
          // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
          alertId: editAlertOpened.alertId,
          IsPrivate,
          tabId,
        }),
      )
    }
  }

  useEffect(() => {
    if (isLoggedIn) {
      // this hack added to fix intake-questions navigation
      if (safeLocalStorage.get(IS_INTAKE_QUESTIONS_FORM) === 'true') {
        safeLocalStorage.remove(IS_INTAKE_QUESTIONS_FORM)
      } else {
        // TODO the hack to fix normal navigation flow
        if (safeLocalStorage.get('isLastPageWasCalendarDetailsView') !== 'true') {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          window.history.pushState(null, null, null)
        }
        // TODO onpopstate hack to fix normal navigation flow
        window.onpopstate = () => {
          // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
          window.history.back(2)
        }
      }
    }
    return () => {
      window.onpopstate = null
    }
  }, [])
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const handleDeleteAlert = (AlertCardId) => {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    dispatch(deleteAlert(patientInfo.PatientId, AlertCardId, tabId))
    setDeletedAlertId(null)
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const handleScriptSureVisitSelected = useCallback(async (visitId) => {
    const response = await getVisitsVisitIdEncounterUrl(visitId)
    const url = response?.ProfileUrl ?? null
    if (url) {
      window.open(url, ...windowOpenArgs)
    }
  }, [])

  const onPressNewPrescriptionsButton = () => {
    const { PatientId, VisitSummary } = patientInfo

    tracking.trackEvent(PROVIDER_EVENT_NAMES.LAUNCH_TREAT, {
      Location: 'Patient Chart',
      PatientId,
      PatientPastVisitCount: VisitSummary?.CountPast,
      PatientUpcomingVisitCount: VisitSummary?.CountUpcoming,
    })

    if (isProviderScriptSure) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getPastVisitsForProduct(id))
      return
    }

    if (patientTreatLink) {
      window.open(patientTreatLink, ...windowOpenArgs)
      dispatch(clearPatientChartTreatLink(id))
    } else {
      openTreatOnSuccess.current = true
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getPatientTreatLink(id, tabId))
    }
  }

  const onGetProducts = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (category) => {
      const { Address, PatientId, VisitSummary } = patientInfo

      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(getProducts(id, category, tabId, Address.StateCode))

      const event =
        category === 'MenopauseHormoneTherapy' ?
          PROVIDER_EVENT_NAMES.LAUNCH_DTS_FOR_MHT
        : PROVIDER_EVENT_NAMES.LAUNCH_DTS_FOR_OUD

      tracking.trackEvent(event, {
        Location: 'Patient Chart',
        PatientId,
        PatientPastVisitCount: VisitSummary?.CountPast || 0,
        PatientUpcomingVisitCount: VisitSummary?.CountUpcoming || 0,
      })
    },
    [dispatch, id, patientInfo, tabId],
  )

  const orderButtonOptions =
    isProviderScriptSure ?
      [
        {
          buttonText: 'Add',
          image: plus,
          imageStyle: AlertsNewBtnImgStyle,
          onPress: onPressNewPrescriptionsButton,
        },
      ]
    : [
        {
          buttonText: 'Treat',
          image: plus,
          imageStyle: AlertsNewBtnImgStyle,
          onPress: onPressNewPrescriptionsButton,
        },
        ...(flags.product_order_types?.includes('OUD') && dtsMoudPilotEnabled ?
          [
            {
              buttonText: 'OUD',
              image: plus,
              imageStyle: AlertsNewBtnImgStyle,
              onPress: () => {
                onGetProducts('moud')
              },
            },
          ]
        : []),
        ...(flags.product_order_types?.includes('MHT') ?
          [
            {
              buttonText: 'MHT',
              image: plus,
              imageStyle: AlertsNewBtnImgStyle,
              onPress: () => {
                onGetProducts('MenopauseHormoneTherapy')
              },
            },
          ]
        : []),
      ]

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const newAlertView = (isEditMode) => (
    <div className={classNames('chart-new-alert-view-container', { 'collapsed-side-panel': isSideCollapsed })}>
      <div className='chart-new-alert-view-header'>
        <label htmlFor='null' className='chart-new-alert-title'>
          {isEditMode ? 'Edit alert' : 'New alert'}
        </label>
        <div className='chart-new-alert-title-switchBox'>
          <div>Visible to all</div>
          <Switch
            onChange={setIsVisibleAllChecked}
            checked={isVisibleAllChecked}
            offColor='#B0BDCB'
            onColor='#00A2B2'
            height={30}
            width={76}
            uncheckedIcon={<div className='unchecked-icon-visible-to-all'>no</div>}
            checkedIcon={<div className='checked-icon-visible-to-all'>yes</div>}
            className={isVisibleAllChecked ? 'switchBoxIsVisibleAlertChecked' : 'switchBoxIsVisibleAlertUnchecked'}
            activeBoxShadow='#ffffff'
          />
        </div>
      </div>
      <TextEditor
        placeHolderText='Type something...'
        isError={alertLocalError}
        setOffErrorHandler={() => {
          setAlertLocalError('')
        }}
        setText={isEditMode ? setEditAlertText : setNewAlertText}
        ref={isEditMode ? editAlertRef : newAlertRef}
        setDescriptionLocalError={setAlertLocalError}
        descriptionLocalError={alertLocalError}
      />
      <div className='chart-limit-counter-container'>
        <CharacterLimitCounter
          currentAmount={isEditMode ? editAlertText.length : newAlertText.length}
          limit={MAX_CHARACTER_LIMIT}
          isHighlightError={
            isEditMode ? editAlertText.length > MAX_CHARACTER_LIMIT : newAlertText.length > MAX_CHARACTER_LIMIT
          }
        />
      </div>

      <div className='chart-new-alert-button-container'>
        {/*
         // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
        <SecondaryButton
          btnText='Cancel'
          containerStyle={{ height: 40, width: 104, padding: 0 }}
          onPress={() => {
            setNewAlertOpened(false)
            setEditAlertOpened(null)
            setIsVisibleAllChecked(true)
          }}
        />
        <PrimaryButton
          btnText='Save'
          containerStyle={{ height: 40, width: 104, marginLeft: 16 }}
          onPress={() => {
            if (isEditMode) handleAddAlert('edit', editAlertText, !isVisibleAllChecked)
            else handleAddAlert('add', newAlertText, !isVisibleAllChecked)
          }}
        />
      </div>
    </div>
  )

  useEffect(() => {
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    if (editAlertRef && editAlertOpened?.message) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      editAlertRef?.current?.onSetValue(editAlertOpened.message)
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setEditAlertText(editAlertOpened.message)
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setIsVisibleAllChecked(!editAlertOpened.IsPrivate)
    }
  }, [editAlertOpened])

  const handleRemoveAllAllergiesPopUp = useCallback(() => {
    setRemoveAllAllergiesPopUp(false)
  }, [])

  const handleConfirmNoAllergies = useCallback(() => {
    setRemoveAllAllergiesPopUp(false)
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    dispatch(setPatientHasNoAllergies(patientInfo.PatientId, tabId))
  }, [dispatch, patientInfo?.PatientId, tabId])

  const handleNoAllergiesClick = useCallback(() => {
    if (patientInfo?.AllergyCollection?.HasNoAllergyConfirmation) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setPatientHasAllergies(patientInfo.PatientId, tabId))
    } else if (patientInfo?.AllergyCollection?.Allergies?.length) {
      setRemoveAllAllergiesPopUp(true)
    } else {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(setPatientHasNoAllergies(patientInfo.PatientId, tabId))
    }
  }, [
    dispatch,
    patientInfo?.AllergyCollection?.HasNoAllergyConfirmation,
    patientInfo?.PatientId,
    patientInfo?.AllergyCollection?.Allergies?.length,
    tabId,
  ])

  const onCloseAllergiesPopUp = useCallback(() => {
    setIsAllergiesPopUpOpened(false)
  }, [])
  const onAddAllergy = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (allergy) => {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(addPatientAllergy(patientInfo.PatientId, allergy, tabId))
    },
    [patientInfo.PatientId, dispatch, tabId],
  )

  const onDeleteAllergy = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (allergyId) => {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      dispatch(deletePatientAllergy(patientInfo?.PatientId, allergyId, tabId))
    },
    [patientInfo?.PatientId, dispatch, tabId],
  )

  const alertChardCardMinHeightWithoutBuilderCondition =
    sortedAlerts?.length === 0 ? 316
    : sortedAlerts?.length > 2 ? 400
    : 330
  const alertHeaderAdditionalClassName = showAlertInfo ? 'chartCardHeaderContainerAdditionalClassName' : ''

  const accountInformationHeaderAdditionalClassName =
    showAccountCardInfo ? 'chartCardHeaderContainerAdditionalClassName' : ''
  const generalInformationHeaderAdditionalClassName =
    isShowGeneralInfo ? 'chartCardHeaderContainerAdditionalClassName' : ''
  const prescriptionCardHeaderAdditionalClassName =
    showPrescriptionsCardInfo ? 'chartCardHeaderContainerAdditionalClassName' : ''
  const pastVisitsCardHeaderAdditionalClassName = showPastVisits ? 'chartCardHeaderContainerAdditionalClassName' : ''
  const upcomingVisitsCardHeaderAdditionalClassName =
    showUpcomingVisits ? 'chartCardHeaderContainerAdditionalClassName' : ''
  const intakeFormsHeaderAdditionalClassName = showIntakeForms ? 'chartCardHeaderContainerAdditionalClassName' : ''
  const onGeneralInfoButtonPress = () => {
    if (isGeneralInfoEditMode) {
      // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
      const generalObject = isShowGeneralInfo ? generalInfoRef.current.checkSave() : generalInfo
      if (!generalObject.isError) {
        if (isNewPatientAgeValueLessThen18 && (!generalObject.HeightInches || !generalObject.WeightPounds)) {
          setGeneralInfo({
            ...generalObject,
            isError: true,
          })
          dispatch(
            setChartError({
              errorMsg: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS),
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              patientId: id,
              tabId,
            }),
          )
          return
        }
        if (generalObject.HeightInches && generalObject.HeightInches < 12) {
          setGeneralInfo({
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            ...generalInfo,
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            isError: getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, text.HEIGHT_FT),
          })
          dispatch(
            setChartError({
              errorMsg: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS),
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              patientId: id,
              tabId,
            }),
          )
          toggleShowGeneralInfo(true)
        } else {
          if (
            patientInfo.HeightInches === generalObject.HeightInches &&
            patientInfo.WeightPounds === generalObject.WeightPounds &&
            getMaritalValue(patientInfo.MaritalStatus) === (generalObject.MaritalStatus || '') &&
            patientInfo.GenderIdentity === generalObject.GenderIdentity &&
            getRacialValue(patientInfo.RacialBackground) === (generalObject.RacialBackground || '')
          ) {
            setIsGeneralInfoEditMode(!isGeneralInfoEditMode)
            return
          }
          dispatch(
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            saveGeneralInfo(
              patientInfo.PatientId,
              {
                ...generalObject,
                RacialBackground:
                  generalObject.RacialBackground ?
                    getRacialEnum(generalObject.RacialBackground)
                  : generalObject.RacialBackground,
                MaritalStatus:
                  generalObject.MaritalStatus ?
                    getMaritalEnum(generalObject.MaritalStatus)
                  : generalObject.MaritalStatus,
              },
              tabId,
            ),
          )
        }
      } else {
        toggleShowGeneralInfo(true)
        dispatch(
          setChartError({
            errorMsg: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS),
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            patientId: id,
            tabId,
          }),
        )
      }
    } else {
      setIsGeneralInfoEditMode(!isGeneralInfoEditMode)
      toggleShowGeneralInfo(true)
    }
  }

  const getGeneralInfoView = () => {
    if (isGeneralInfoEditMode) {
      return (
        <GeneralInfoEdit
          ref={generalInfoRef}
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          patientInfo={patientInfo}
          identity={identityData}
          height={patientInfo?.HeightInches}
          weight={patientInfo.WeightPounds}
          generalInfo={generalInfo}
          isNewPatientAgeValueLessThen18={isNewPatientAgeValueLessThen18}
        />
      )
    }
    return (
      <>
        {/*
         // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
        <InfoCard title={text.BODY_MEASUREMENTS} info={bodyMeasurementsData} id='BodyMeasurementsCard' />
        {/*
         // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
        <InfoCard title={text.IDENTITY} info={identityData} id='IdentityCard' isTooltipOutside />
      </>
    )
  }
  useEffect(() => {
    if (openTreatOnSuccess.current && patientTreatLink) {
      openTreatOnSuccess.current = false
      onPressNewPrescriptionsButton()
    }
  }, [openTreatOnSuccess, patientTreatLink])

  const onAccountInformationButtonPress = () => {
    if (!isAccountInformationEditMode) {
      setIsAccountInformationEditMode(true)
      setsShowAccountCardInfo(true)
    } else {
      setIsAccountInformationSaveBtnClicked(true)
    }
  }

  useEffect(() => {
    if (isAccountInformationSaveBtnClicked) {
      if (!isCheckNumberInProgress) {
        setIsAccountInformationSaveBtnClicked(false)
        // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
        const accountInfoObject = showAccountCardInfo ? accountInfoRef.current.getInfo() : accountCardInfo
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        const DOBValuesList = accountInfoObject.dateOfBirthValue?.split('/').filter((value) => value)
        const monthDOBValue = DOBValuesList?.[0]
        const dateDOBValue = DOBValuesList?.[1]
        const yearDOBValue = DOBValuesList?.[2]
        if (accountInfoObject.dateOfBirthValue.length < 10) {
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          setAccountCardInfo((prev) => ({ ...prev, isError: true }))
          dispatch(
            setChartError({
              errorMsg: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS),
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              patientId: id,
              tabId,
            }),
          )
          return
        }

        if (
          accountInfoObject.contactPharmacyValue !== accountInfoObject.selectedPharmacyAddress ||
          (accountInfoObject.emergencyPhoneError && patientInfo?.EmergencyContact) ||
          DOBValuesList?.length < 3 ||
          !moment(`${dateDOBValue}-${monthDOBValue}-${yearDOBValue}`, 'DD-MM-YYYY').isValid() ||
          yearDOBValue?.length < 4 ||
          moment(`${dateDOBValue}-${monthDOBValue}-${yearDOBValue}`, 'DD-MM-YYYY').isAfter(new Date()) ||
          moment(`${dateDOBValue}-${monthDOBValue}-${yearDOBValue}`, 'DD-MM-YYYY').isBefore('1901-01-01', 'year')
        ) {
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          setAccountCardInfo((prev) => ({ ...prev, isError: true }))
          dispatch(
            setChartError({
              errorMsg: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS),
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              patientId: id,
              tabId,
            }),
          )
          return
        }

        const isEmergencyContactChanged =
          accountInfoObject.emergencyFirstNameValue?.trim() !== (patientInfo?.EmergencyContact?.FirstName || '') ||
          accountInfoObject.emergecyLastNameValue?.trim() !== (patientInfo?.EmergencyContact?.LastName || '') ||
          accountInfoObject.emergencyRelationshipValue?.trim() !==
            (patientInfo?.EmergencyContact?.Relationship || '') ||
          accountInfoObject.emergencyPhoneNumber?.trim() !==
            (patientInfo?.EmergencyContact?.PhoneNumber?.Number?.substr(
              patientInfo?.EmergencyContact?.PhoneNumber?.Prefix?.length,
            ) || '') ||
          accountInfoObject.emergencyPhoneCountry !==
            (patientInfo?.EmergencyContact?.PhoneNumber?.CountryCode?.toLowerCase() || 'us')

        if (!accountInfoObject.isResetEmergency && isEmergencyContactChanged) {
          const isNumberTheSameAsPatientsNumber =
            patientInfo?.PhoneNumber?.Number ===
            `+${accountInfoObject?.emergencyPhoneCountryCode}${accountInfoObject?.emergencyPhoneNumber}`
          if (
            !accountInfoObject.emergencyFirstNameValue?.trim() ||
            !accountInfoObject.emergecyLastNameValue?.trim() ||
            !accountInfoObject.emergencyRelationshipValue?.trim() ||
            !accountInfoObject.emergencyPhoneNumber?.trim() ||
            isNumberTheSameAsPatientsNumber
          ) {
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            setAccountCardInfo((prev) => ({ ...prev, isEmergencyContactError: true }))
            setIsEmergencyError(true)
            dispatch(
              setChartError({
                errorMsg: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS),
                // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                patientId: id,
                tabId,
              }),
            )
            return
          }
        }

        if (
          accountInfoObject.prefferedNameValue?.trim() === (patientInfo.PreferredName || '') &&
          !isEmergencyContactChanged &&
          accountInfoObject.contactPharmacyValue === (getPharmacyAddressValue(patientInfo.Pharmacy) || '') &&
          accountInfoObject.emergencyPhoneNumber?.trim() ===
            (patientInfo?.EmergencyContact?.PhoneNumber?.Number?.substr(
              patientInfo?.EmergencyContact?.PhoneNumber?.Prefix?.length,
            ) || '') &&
          accountInfoObject.emergencyPhoneCountry ===
            (patientInfo?.EmergencyContact?.PhoneNumber?.CountryCode?.toLowerCase() || 'us') &&
          accountInfoObject.dateOfBirthValue === moment(patientInfo.BirthDate).format('MM/DD/YYYY')
        ) {
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          setAccountCardInfo((prev) => ({ ...prev, isEmergencyContactError: false }))
          setIsAccountInformationEditMode(false)
          return
        }

        const ageValue = moment().diff(
          moment(`${dateDOBValue}-${monthDOBValue}-${yearDOBValue}`, 'DD-MM-YYYY'),
          'years',
        )

        if (ageValue < 18) {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          const generalObject = isShowGeneralInfo ? generalInfoRef?.current?.checkSave() : generalInfo
          const heightValue = generalObject?.HeightInches || patientInfo?.HeightInches
          const weightValue = generalObject?.WeightPounds || patientInfo?.WeightPounds

          if (!patientInfo.HeightInches || !patientInfo.WeightPounds) {
            setIsShowGeneralInfo(true)
            setIsGeneralInfoEditMode(true)
            setIsNewPatientAgeValueLessThen18(true)
            const generalInfoSectionElement = document.getElementById('GeneralInformationCard')
            // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
            generalInfoSectionElement.scrollIntoView({ behavior: 'smooth' })
            if (heightValue && weightValue) {
              dispatch(
                setChartError({
                  errorMsg: getUserFriendlyErrorMessage(errorCodes.PLEASE_SAVE_GENERAL_INFO_BEFORE),
                  // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                  patientId: id,
                  tabId,
                }),
              )
            }
            return
          }
        } else {
          setIsShowGeneralInfo(false)
          setIsGeneralInfoEditMode(false)
          setIsNewPatientAgeValueLessThen18(false)
        }

        if (accountInfoObject.emergencyPhoneError) {
          dispatch(
            setChartError({
              errorMsg: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS),
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              patientId: id,
              tabId,
            }),
          )
          return
        }

        const newAccountInfoConfig = {
          PreferredName: accountInfoObject.prefferedNameValue?.trim(),
          PharmacyId: accountInfoObject.selectedPharmacyId || null,
          BirthDate: `${yearDOBValue}-${monthDOBValue}-${dateDOBValue}`,
          EmergencyContact:
            accountInfoObject.isResetEmergency ? null : (
              {
                FirstName: accountInfoObject.emergencyFirstNameValue?.trim(),
                LastName: accountInfoObject.emergecyLastNameValue?.trim(),
                Relationship: accountInfoObject.emergencyRelationshipValue?.trim(),
                PhoneNumber: {
                  CountryCode: accountInfoObject.emergencyPhoneCountry,
                  Prefix: `+${accountInfoObject.emergencyPhoneCountryCode}`,
                  Number: `+${accountInfoObject.emergencyPhoneCountryCode + accountInfoObject.emergencyPhoneNumber}`,
                },
              }
            ),
        }
        dispatch(
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          saveAccountInfo({
            patientId: id,
            info: newAccountInfoConfig,
            pharmacyInfo: accountInfoObject.selectedPharmacy,
            tabId,
          }),
        )
      }
    }
  }, [isCheckNumberInProgress, isAccountInformationSaveBtnClicked])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangeFileUpload = (event) => {
    const files = event?.target?.files?.[0]
    const extension = files.name.split('.').pop().toLowerCase()
    const isAllowedExtension = ALLOWED_FILE_EXTENSIONS.includes(extension)
    const isAllowedSize = files.size <= SIZE_10_MB

    if (!isAllowedExtension) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setUploadFileError(getUserFriendlyErrorMessage(errorCodes.INVALID_FILE_FORMAT, null, ALLOWED_FILE_EXTENSIONS_STR))
    } else if (!isAllowedSize) {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setUploadFileError(getUserFriendlyErrorMessage(errorCodes.TOO_BIG_FILE_SIZE, null, '10 MB'))
    }

    event.target.value = null

    if (files && isAllowedExtension && isAllowedSize) {
      setUploadedFile(files)
      openUploadFilePopUp()
    }
  }

  useEffect(() => {}, [])

  const correctErrorMessage =
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    error === getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, text.PHONE_NUMBER) ?
      getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)
    : error
  function onFilesAddedSuccess() {
    // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
    fileCardRef.current.onFilesAddedSuccess()
  }

  if (isObjectEmpty(patientInfo) && !loading) {
    navigate('/NotFound404')
  }
  const clearForm = useCallback(() => {
    // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
    allergiesPopUpRef?.current.clearForm()
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const setToastErrorMessage = (errorMessage) => {
    // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
    dispatch(setChartError({ errorMsg: errorMessage, patientId: id, tabId }))
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  function handleClickViewFile(file) {
    tracking.trackEvent(PROVIDER_EVENT_NAMES.VIEW_FILE, {
      FileName: file.FileName,
      FileTags: file.Tags,
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      PatientId: id,
      UploadedBy: file.Author.UserType,
      UploadDateTime: file.UploadDateTime,
    })
  }

  return (
    <div>
      <ProductOrderPopUp
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        patientId={id}
        pharmacy={patientInfo?.Pharmacy}
        address={patientInfo?.Address}
        isRefillAllowed={patientInfo.IsRefillAllowed}
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        tabId={tabId}
        getOrders={() => {
          queryClient.invalidateQueries({
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            queryKey: getGetPatientsPatientIdPrescriptionsQueryKey(id),
          })
        }}
        onVisitSelected={isProviderScriptSure ? handleScriptSureVisitSelected : undefined}
      />

      {prescription ?
        <PrescriptionPopUp
          isProvider
          prescription={prescription}
          onClose={() => {
            setPrescription(null)
          }}
        />
      : null}
      <ChartListener
        onClearForm={clearForm}
        setLocalLoading={setLocalLoading}
        setLocalToastErrorMessage={setLocalToastErrorMessage}
        closeGeneralEdit={() => {
          setIsGeneralInfoEditMode(false)
          setGeneralInfo(null)
        }}
        patientId={id}
        deleteAlertsSuccess={deleteAlertsSuccess}
        alertAddedSuccess={alertAddedSuccess}
        filesAddedSuccess={() => {
          onFilesAddedSuccess()
        }}
        closeUpload={closeUploadFilePopUp}
        openFiles={() => {
          if (!filesHasOpened) {
            setIsShowFiles(true)
            setFilesHasOpened(true)
          }
        }}
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        deleteAlertId={deleteAlertId}
        updateAccountInfo={updateAccountInfo}
        setIsShowFileCardPopup={setIsShowFileCardPopup}
        isNeedToUpdatePastVisits={isNeedToUpdatePastVisits}
        setIsNeedToUpdateLocalPastVisitsList={setIsNeedToUpdateLocalPastVisitsList}
        setSuccessDeletedAlertId={setSuccessDeletedAlertId}
      />
      {deleteAlertId ?
        <DeleteAlertPopUp
          setPopUpOpened={setDeletedAlertId}
          deleteAlertHandler={() => {
            handleDeleteAlert(deleteAlertId)
          }}
        />
      : null}
      {isUploadFilePopUp ?
        <div className='patient-charts-upload-new-file-pop-up-wrapper'>
          <UploadFilePopUp
            patientId={id}
            file={uploadedFile}
            close={closeUploadFilePopUp}
            // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
            addMediaFile={(file) => {
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              dispatch(addMediaFile(file, mediaFiles, filesHasOpened, tabId))
            }}
            setToastErrorMessage={setToastErrorMessage}
            patientDrugRules={patientDrugRules}
          />
        </div>
      : null}
      {localToastErrorMessage || uploadFileError ?
        <div className='patientChart-error-toast-message'>
          <ErrorAlert
            styleContainer={styleContainer}
            errorText={correctErrorMessage || uploadFileError || localToastErrorMessage}
            errorImg={errorIcon}
            imgAlt='Error'
          />
        </div>
      : null}
      {removeAllAllergiesPopUp ?
        // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
        <ConfirmationPopup
          primaryBtnAction={handleConfirmNoAllergies}
          title={ARE_YOU_SURE}
          msg={REMOVE_ALLERGIES_CONFIRMATION}
          primaryBtnText={CONFIRM_TEXT}
          popUpBoxStyle={removeAllAllergiesPopUpStyle}
          secondaryBtnAction={handleRemoveAllAllergiesPopUp}
          secondaryBtnText={CANCEL_TEXT}
          closeAction={handleRemoveAllAllergiesPopUp}
          additionalContainerClass='patient-chart-allergy-confirmation-popup'
        />
      : null}
      {isAllergiesPopUpOpened ?
        <AllergiesPopUp
          ref={allergiesPopUpRef}
          closePopUpCallback={onCloseAllergiesPopUp}
          allergiesList={patientInfo?.AllergyCollection?.Allergies || []}
          hasNoAllergies={patientInfo?.AllergyCollection?.HasNoAllergyConfirmation}
          toggleNoAllergies={handleNoAllergiesClick}
          position='fixed'
          localError={allergySeverityError || allergyNameError}
          setError={() => {
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            dispatch(setChartError({ errorMsg: text.PLEASE_FILL_ALL_FIELDS, patientId: id, tabId }))
          }}
          addPatientAllergy={onAddAllergy}
          deletePatientAllergy={onDeleteAllergy}
          fieldRequiredAllergyError={text.FIELD_REQUIRED_ALLERGY_ERROR}
          fieldRequiredSeverityError={text.FIELD_REQUIRED_SEVERITY_ERROR}
          uniqueError={text.ALLERGY_UNIQUE_ERROR}
          validationError={text.ALLERGY_VALIDATION_ERROR}
          shouldShow={!removeAllAllergiesPopUp}
        />
      : null}

      {localLoading ?
        <PageLoadingSpinner />
      : null}

      <PageLayout>
        <div className='patient-chart-container'>
          {pageHeader}
          {patientInfo?.FirstName ?
            <PatientInfoTile
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              restrictionStatus={transformBackendToUIStatus(patientInfo.RestrictionStatus)}
              isShowNamesPopUp={isShowNamesPopUp}
              allergiesCount={allergiesCount}
              onIsAllergiesPopUpOpened={setIsAllergiesPopUpOpened}
            />
          : null}
          <div className='patient-chart-body'>
            {/*
             // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
            <ChartCard
              title='Alerts'
              chartCardHeaderContainerAdditionalClassName={alertHeaderAdditionalClassName}
              isWithNewIndicator={patientInfo?.AlertSummary?.HasUnread}
              key={alertsKey}
              // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
              lastUpdate={sortedAlerts.length ? sortedAlerts[0].UpdateDateTime : null}
              chartCardId='AlertCard'
              emptyText={alertsEmptyMsg || localAlertsEmptyMessage}
              minimalExpandedHeight={alertChardCardMinHeightWithoutBuilderCondition}
              minimalHeightWithNewSection='615px'
              image={flag}
              additionalImageIconStyle={{ marginTop: '22.5px' }}
              rightButton={
                !newAlertOpened && !editAlertOpened ?
                  // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
                  <SecondaryButton
                    btnText='New'
                    containerStyle={AlertsNewBtnContainerStyle}
                    image={plus}
                    imageAlt='AlertsNew'
                    imageStyle={AlertsNewBtnImgStyle}
                    onPress={onPressAlertsNewBtn}
                  />
                : null
              }
              data={sortedAlerts}
              renderInfo={getAlertView}
              extraView={newAlertOpened ? newAlertView : null}
              extraEditView={editAlertOpened ? newAlertView : null}
              patientInfo={patientInfo}
              showInfo={showAlertInfo}
              toggleShowInfo={toggleShowAlertsCardInfo}
            />
            {/*
             // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered */}
            <ChartCard
              className={`patient-chart-account-information-card${
                isAccountInformationEditMode ? 'patient-chart-account-information-card--edit-mode' : ''
              }`}
              key={accountData.length}
              chartCardHeaderContainerAdditionalClassName={accountInformationHeaderAdditionalClassName}
              minimalExpandedHeight={isAccountInformationEditMode ? 1085 : 541}
              title={text.ACCOUNT_INFORMATION}
              lastUpdate={!localLoading ? accountInfoLastUpdateInfo : null}
              chartCardId='AccountInfoCard'
              image={accountInfoIcon}
              data={accountData}
              patientInfo={patientInfo}
              showInfo={showAccountCardInfo}
              toggleShowInfo={toggleShowAccountCardInfo}
              rightButton={
                // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
                <SecondaryButton
                  btnText={isAccountInformationEditMode ? text.SAVE : text.EDIT}
                  containerStyle={isAccountInformationEditMode ? saveButton : editButton}
                  onPress={onAccountInformationButtonPress}
                />
              }
              renderInfo={() => (
                <AccountInformationView
                  ref={accountInfoRef}
                  // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                  isEditMode={isAccountInformationEditMode}
                  isSaveBtnClicked={isAccountInformationSaveBtnClicked}
                  setIsSaveBtnClicked={setIsAccountInformationSaveBtnClicked}
                  setIsEditMode={setIsAccountInformationEditMode}
                  isCheckNumberInProgress={isCheckNumberInProgress}
                  setIsCheckNumberInProgress={setIsCheckNumberInProgress}
                  accountInfoData={accountCardInfo}
                  setAccountInfoData={setAccountCardInfo}
                />
              )}
            />
            {/*
             // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered */}
            <ChartCard
              isWithoutLastUpdate
              className='patient-chart-general-information-card'
              chartCardHeaderContainerAdditionalClassName={generalInformationHeaderAdditionalClassName}
              key={useId()}
              minimalExpandedHeight={isGeneralInfoEditMode ? 594 : 321}
              title={text.GENERAL_INFORMATION}
              lastUpdate=''
              chartCardId='GeneralInformationCard'
              image={generalInfoSectionIcon}
              data={accountData}
              patientInfo={patientInfo}
              showInfo={isShowGeneralInfo}
              toggleShowInfo={toggleShowGeneralInfo}
              rightButton={
                // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
                <SecondaryButton
                  btnText={isGeneralInfoEditMode ? text.SAVE : text.EDIT}
                  containerStyle={isGeneralInfoEditMode ? saveButton : editButton}
                  onPress={onGeneralInfoButtonPress}
                />
              }
              renderInfo={getGeneralInfoView}
            />
            {/*
             // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered */}
            <ChartCard
              isWithoutLastUpdate
              className='patient-chart-prescriptions-card'
              emptyText={!isPrescriptionsLoading && 'No prescriptions'}
              chartCardHeaderContainerAdditionalClassName={prescriptionCardHeaderAdditionalClassName}
              minimalExpandedHeight={localPrescriptionsList.length === 0 ? 316 : 615}
              title={text.ORDERS}
              lastUpdate=''
              chartCardId='PrescriptionsCard'
              image={prescripitionsIcon}
              data={isPrescriptionsLoading ? [null] : localPrescriptionsList}
              patientInfo={patientInfo}
              renderInfo={getPrescriptionsView}
              showInfo={showPrescriptionsCardInfo}
              toggleShowInfo={toggleShowPrescriptionsCardInfo}
              rightButton={
                orderButtonOptions.length > 1 ?
                  <ButtonOptionsSelector
                    options={orderButtonOptions}
                    className='patient-chart-button-option-selector-container'
                  />
                  // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
                : <SecondaryButton
                    btnText='New'
                    containerStyle={AlertsNewBtnContainerStyle}
                    image={plus}
                    imageAlt='AlertsNew'
                    imageStyle={AlertsNewBtnImgStyle}
                    onPress={onPressNewPrescriptionsButton}
                  />
              }
            />
            {/*
             // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered */}
            <ChartCard
              isWithoutLastUpdate
              className='patient-chart-past-visit-card'
              emptyText={
                localLoading && patientInfo?.VisitSummary?.CountPast && pastVisits.length ? '' : text.NO_PAST_VISITS
              }
              chartCardHeaderContainerAdditionalClassName={pastVisitsCardHeaderAdditionalClassName}
              minimalExpandedHeight={
                localPastVisitsList.length === 0 ? 316
                : localPastVisitsList.length < 3 ?
                  285
                : 469
              }
              title={text.PAST_VISITS}
              lastUpdate=''
              chartCardId='pastvisits'
              image={pastVisitsIcon}
              data={localPastVisitsList}
              patientInfo={patientInfo}
              renderInfo={getPastVisitsView}
              showInfo={showPastVisits}
              toggleShowInfo={toggleShowPastVisits}
            />
            {/*
             // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered */}
            <ChartCard
              isWithoutLastUpdate
              className='patient-chart-upcoming-visit-card'
              emptyText={
                localLoading && patientInfo?.VisitSummary?.CountUpcoming && localUpcomingVisitsList.length ?
                  ''
                : text.NO_UPCOMING_VISITS
              }
              chartCardHeaderContainerAdditionalClassName={upcomingVisitsCardHeaderAdditionalClassName}
              minimalExpandedHeight={
                localUpcomingVisitsList.length === 0 ? 316
                : localUpcomingVisitsList.length < 3 ?
                  285
                : 469
              }
              title={text.UPCOMING_VISITS}
              lastUpdate=''
              chartCardId='upcomingvisits'
              image={upcomingVisitsIcon}
              data={localUpcomingVisitsList}
              patientInfo={patientInfo}
              renderInfo={getUpcomingVisitsView}
              showInfo={showUpcomingVisits}
              toggleShowInfo={toggleShowUpcomingVisits}
            />
            {/*
             // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered */}
            <ChartCard
              isWithoutLastUpdate
              className='patient-chart-intake-forms-card'
              emptyText={
                localLoading && (patientInfo?.IntakeFormSummary?.Count || questionnaires.length) ?
                  ''
                : 'No intake forms'
              }
              chartCardHeaderContainerAdditionalClassName={intakeFormsHeaderAdditionalClassName}
              minimalExpandedHeight={397}
              title={text.INTAKE_FORMS}
              lastUpdate=''
              chartCardId='intakeForms'
              image={intakeFormsIcon}
              data={intakeFormsAndQuestionnaires}
              patientInfo={patientInfo}
              renderInfo={() =>
                intakeFormsAndQuestionnaires.map((item, index) => {
                  const intakeData = accountInfo(item, text.INTAKE_FORMS)
                  const linkTo =
                    item.isQuestionnaire ?
                      `${PATIENT_CHART_INTAKE_QUESTIONS_PAGE_PATH}/?id=${id}&sessionId=${item.QuestionnaireSessionId}`
                    : `${PATIENT_CHART_INTAKE_QUESTIONS_PAGE_PATH}/?id=${id}&intakeFormId=${item.IntakeFormId}`
                  return (
                    // @ts-expect-error TS2741 -- MIGRATION: not approved, fix when encountered
                    <InfoCard
                      info={intakeData}
                      id={item.isQuestionnaire ? `questionnaireCard-${index}` : `intakeCard-${index}`}
                      isTooltipOutside
                      extraStyle={{ marginBottom: '16px' }}
                      hasArrowIcon
                      linkTo={linkTo}
                    />
                  )
                })
              }
              showInfo={showIntakeForms}
              toggleShowInfo={toggleIntakeForms}
            />

            {/*
             // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered */}
            <ChartCard
              isWithoutLastUpdate
              isWithoutSeparatedLine
              className='patient-chart-files-card'
              emptyText={
                localLoading || (patientInfo?.MediaFileSummary?.Count && filteredMediaFiles.length) ? '' : NO_FILES_TEXT
              }
              title={FILES_TEXT}
              minimalHeightWithNewSection={
                filteredMediaFiles.length < 3 ?
                  mediaFiles.length ?
                    408
                  : 316
                : mediaFiles.length ?
                  632
                : 540
              }
              minimalExpandedHeight={
                filteredMediaFiles.length < 3 ?
                  mediaFiles.length ?
                    408
                  : 316
                : mediaFiles.length ?
                  632
                : 540
              }
              lastUpdate=''
              chartCardId='files'
              image={filesIcon}
              data={filteredMediaFiles}
              patientInfo={patientInfo}
              renderInfo={() => (
                <div className='patient-chart-files-list-container'>
                  {/*
                   // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered */}
                  {filteredMediaFiles.map((file, index) => (
                    <FileCard
                      ref={fileCardRef}
                      {...file}
                      className='patient-chart-file-card-wrapper'
                      apiCall={apiCall}
                      key={file.FileId}
                      index={index}
                      patientId={id}
                      isShowPopup={isShowFileCardPopup}
                      setIsShowPopup={setIsShowFileCardPopup}
                      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                      dateTimeString={parseUserDateTime(file.UploadDateTime, parseTimeZone(profile.TimeZone), false)}
                      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                      setMediaFileTags={(mediaFile) => {
                        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
                        dispatch(setMediaFileTags(mediaFile, mediaFiles, tabId))
                      }}
                      setToastErrorMessage={setToastErrorMessage}
                      onClickViewFile={handleClickViewFile}
                      patientDrugRules={patientDrugRules}
                    />
                  ))}
                </div>
              )}
              extraView={mediaFiles.length ? getTagFilter : null}
              showInfo={isShowFiles}
              toggleShowInfo={toggleMediaFiles}
              rightButton={
                <label htmlFor='file-card-file-upload' className='file-card-file-upload'>
                  {/*
                   // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
                  <SecondaryButton
                    btnText={
                      <>
                        <span>New&nbsp;</span>
                        <input
                          type='file'
                          id='file-card-file-upload'
                          accept={ALLOWED_FILE_EXTENSIONS_STR}
                          onChange={onChangeFileUpload}
                        />
                      </>
                    }
                    image={plus}
                    imageAlt='AlertsNew'
                    imageStyle={AlertsNewBtnImgStyle}
                    onPress={noop}
                  />
                </label>
              }
            />
          </div>
        </div>
      </PageLayout>
    </div>
  )
}
export default PatientChart
